/** Formats quizzes_due_today for nav badges (e.g. 14, 999, 1K, 1.1K). */
export const formatQuizzesDueTodayCount = (count: number): string => {
  const safeCount = Math.max(0, Math.floor(count))

  if (safeCount < 1000) {
    return String(safeCount)
  }

  const valueInThousands = safeCount / 1000
  const roundedToOneDecimal = Math.floor(valueInThousands * 10) / 10
  const formatted = Number.isInteger(roundedToOneDecimal)
    ? String(roundedToOneDecimal)
    : roundedToOneDecimal.toFixed(1)

  return `${formatted}K`
}
